<template>
                            <code>
                                &lt;head><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://swarm.video/jwplayer/swarm-provider.js">&lt;/script><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://swarm.video/swarm.js">&lt;/script><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;script>
                                src="//cdn.jsdelivr.net/npm/clappr@latest/dist/clappr.min.js">&lt;/script><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;script
                                src="https://content.jwplatform.com/libraries/aG3IMhIy.js">&lt;/script><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://cdn.jsdelivr.net/npm/hls.js@latest">&lt;/script><br>
                                &lt;/head><br>
                                &lt;body><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;div id="wrapper"><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;div id="player"> &lt;/div><br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;/div><br>

                                &lt;/body><br>
                                &lt;script>
                                <br>
                                let engine = new p2pml.hlsjs.Engine({segments: {swarmId: "CustomSwarmId"},loader: {httpUseRanges:false, WaitForTracker: true, WaitForTrackerCounter:4500}}); <br>

                                var player = jwplayer("player");<br>
                                player.setup({<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;file:'https://wowza.peer5.com/live/smil:bbb_abr.smil/playlist.m3u8',<br>
                                });<br>
                                jwplayer_hls_provider.attach();<br>
                                p2pml.hlsjs.initJwPlayer(player, {<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;liveSyncDurationCount: 7, // To have
                                at least 7 segments in queue<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;loader: engine.createLoaderClass()<br>
                                });<br>

                                &lt;/script><br>

                            </code>
</template>

<script>
export default {
  name: "jwvideo",
};
</script>
